module.exports = __webpack_public_path__ + "static/img/zh_HANT3.e297b8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zh_HANT3.png
// module id = 7WkA
// module chunks = 1